// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"38aba66b80eeac1bcf39","147":"029137a0867299eaaebc","251":"972d3e798c1f5ef8c136","352":"a24e00e897355eeff304","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};